module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "service-page"
  }, [(_vm.$route.name === 'services') ? _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Our Services")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'trees'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg trees"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tree Relocation")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Why a Tree Spade")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Site Considerations")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("The Process")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Post-Relocation Care")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'erosion'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg hydro"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Erosion Control")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Hydroseeding")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Drillseeding")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Silt Fencing")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Blankets/Logs")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'rows'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg rows"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Row Maintenance")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Litter Removal")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Roadside Mowing")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Roadside Edging & Sweeping")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Herbicide Application")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'landscape'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg landscape"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Landscaping")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Excavation")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Planting")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Irrigation")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Hardscapes")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'irrigation'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg irrigation"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Irrigation")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Drip Systems")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Popup Systems")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Directional Spray")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("WiFi Controllers")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'hydroaxe'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg hydroaxe"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Hydro-Axing")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Erosion Prevention")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Soil Stabilization")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Moisture Retention")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Wildlife Protection")])])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'services') ? _c('div', {
    staticClass: "hero is-large"
  }, [_c('div', {
    class: ( _obj = {
      'hero-body hero-image': true
    }, _obj[_vm.$route.name] = true, _obj )
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'services') ? _c('div', {
    staticClass: "service-container"
  }, [_c('router-view')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d1b1a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services.vue
// module id = 153
// module chunks = 1